import
  React
from 'react';

import {
  HContainer,
  JourneyProvider,
  Text,
  VContainer
} from '@vodacom/web-common';

import {
  CustomColors
} from '../../../constants';

import {
  CheaperBundles,
  NoOffers
} from '.';

import {
  PrimaryButton,
  SecondaryButton
} from 'components';

export const Offers = props => {

  const [
    state,
    setState
  ] = React.useState({
    canUseLocation: JourneyProvider.get('Common', 'canUseLocation'),
    loading: false,
    error: null
  });

  const buildLocationPermission = () => {

    return (

      <VContainer
        padding={'20px'}
        boxShadow={`0px 5px 15px ${CustomColors.TransparentBlack1}`}
        borderRadius={'4px'}>

        <Text
          fontSize={'14px'}
          color={CustomColors.Grey9}
          textAlign={'center'}>

          {'To get cheaper bundle offers, we need your permission to use your location.'}
        </Text>

        <HContainer
          margin={'16px 0 0'}>

          <SecondaryButton
            margin={'0 16px 0 0'}
            padding={'16px'}
            text={'Decline'}
            onClick={() => {

              JourneyProvider.set(
                'Common',
                { canUseLocation: 'no' },
                true
              );

              setState(prevState => ({
                ...prevState,
                canUseLocation: 'no'
              }));
            }}/>

          <PrimaryButton
            padding={'16px'}
            text={'Accept'}
            onClick={() => {

              JourneyProvider.set(
                'Common',
                { canUseLocation:'yes' },
                true
              );

              props.onAgree();

              setState(prevState => ({
                ...prevState,
                canUseLocation: 'yes'
              }));
            }}/>

        </HContainer>
      </VContainer>
    );
  };

  return (
    <>

      { state?.canUseLocation === undefined

        ? buildLocationPermission()

        : state?.canUseLocation === 'yes'

          ? <CheaperBundles/>

          : <NoOffers/>
      }
    </>
  );
};
